import { apiUrl } from "../config/apiBase";

export async function stiahniAdminUsersCsv() {
  const response =
    await fetch(
      apiUrl(
        "/api/admin/users/export-csv"
      ),
      {
        credentials:
          "include"
      }
    );

  if (!response.ok) {
    const data =
      await response
        .json()
        .catch(
          () => ({})
        );

    throw new Error(
      data?.message ||
        "CSV export sa nepodarilo vytvoriť."
    );
  }

  const blob =
    await response.blob();

  const disposition =
    String(
      response.headers.get(
        "Content-Disposition"
      ) || ""
    );

  const match =
    disposition.match(
      /filename="([^"]+)"/i
    );

  const nazovSuboru =
    match?.[1] ||
    "fincloud-pouzivatelia.csv";

  const url =
    URL.createObjectURL(
      blob
    );

  const link =
    document.createElement(
      "a"
    );

  link.href =
    url;

  link.download =
    nazovSuboru;

  document.body.appendChild(
    link
  );

  link.click();

  link.remove();

  URL.revokeObjectURL(
    url
  );
}